import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export default class TextUppercase extends Plugin {
	init() {
		const editor = this.editor;
        const model = editor.model;
		const selection = model.document.selection;
		const schema = model.schema;
		const conversion = editor.conversion;

		schema.extend( '$text', { allowAttributes: 'textTransform' } );
		schema.setAttributeProperties( 'textTransform', { isFormatting: true } );

		conversion.attributeToElement( {
			model: {
				key: 'textTransform',
				values: [ 'uppercase' ],
				name: '$text'
			},

			view: {
				uppercase: {
					name: 'span',
					styles: {
						'text-transform': 'uppercase'
					}
				}
			}
		} );

		editor.ui.componentFactory.add( 'textUppercase', locale => {
            const view = new ButtonView( locale );
			const translate = editor.t;

            view.set( {
                label: translate('Text uppercase'),
                withText: true,
                tooltip: true
            } );

            view.on( 'execute', () => {
                const ranges = schema.getValidRanges( selection.getRanges(), 'textTransform' );

                for ( const range of ranges ) {
                    model.change( writer => {
                        writer.setAttribute( 'textTransform', 'uppercase', range )
                    } );
                }
            });

            return view;
        });
	}
}
